/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ place: NonNullable<unknown>, km: NonNullable<unknown> }} Requirements_Area_AroundInputs */

const cs_requirements_area_around = /** @type {(inputs: Requirements_Area_AroundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.place} · ${i?.km} km`)
};

const en_requirements_area_around = /** @type {(inputs: Requirements_Area_AroundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.place} · ${i?.km} km`)
};

/**
* | output |
* | --- |
* | "{place} · {km} km" |
*
* @param {Requirements_Area_AroundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_area_around = /** @type {((inputs: Requirements_Area_AroundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Area_AroundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_area_around(inputs)
	return cs_requirements_area_around(inputs)
});